import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment';
import Genjin from '../public/genjin.js';

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {},
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        fetch('/ProjectResource/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                data.condition = data.data ? data.data : {}
                that.setState({
                    ...data
                })
            })
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    arrRych(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Tag color={'blue'}>{item}</Tag>
            )
        }
    }

    render() {

        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{ padding: 15 }} width={1200}
                    visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>项目信息</div>
                        <div className={'view_info view_info2'}>
                            <div className={'item'}>
                                <div className={'p1'}>项目名称</div>
                                <div className={'p2'}>{this.state.condition.title}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>项目进度</div>
                                <div className={'p2'}>
                                    {this.state.condition.project_progress == 1 ? <Tag color="blue">{this.state.condition.project_progress_text}</Tag> : null}
                                    {this.state.condition.project_progress == 2 ? <Tag color="green">{this.state.condition.project_progress_text}</Tag> : null}
                                    {this.state.condition.project_progress == 3 ? <Tag color="grey">{this.state.condition.project_progress_text}</Tag> : null}
                                </div>
                            </div>
                            {this.state.condition.project_progress == 2 ?
                                <>
                                    <div className={'item'}>
                                        <div className={'p1'}>落地时间</div>
                                        <div className={'p2'}>{this.state.condition.landing_time}</div>
                                    </div>
                                    <div className={'item'}>
                                        <div className={'p1'}>落地载体</div>
                                        <div className={'p2'}>{this.state.condition.landing_carrier}</div>
                                    </div>
                                </>
                                : null}
                            {this.state.condition.project_progress == 3 ?
                                <>
                                    <div className={'item'}>
                                        <div className={'p1'}>终止时间</div>
                                        <div className={'p2'}>{this.state.condition.end_time}</div>
                                    </div>
                                </>
                                : null}
                            <div className={'item'}>
                                <div className={'p1'}>项目负责人</div>
                                <div className={'p2'}>{this.state.condition.fzr_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>首次开拓时间</div>
                                <div className={'p2'}>{this.state.condition.sckt_time}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>项目来源</div>
                                <div className={'p2'}>{this.state.condition.origin_place}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>中介/基金名称</div>
                                <div className={'p2'}>{this.state.condition.fund_agency_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>投资方（企业全称）</div>
                                <div className={'p2'}>{this.state.condition.qy_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>联系人</div>
                                <div className={'p2'}>{this.state.condition.lxr_name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>联系电话</div>
                                <div className={'p2'}>{this.state.condition.lxr_mobile}</div>
                            </div>
                            {/* <div className={'item'}>
                                <div className={'p1'}>资本类型</div>
                                <div className={'p2'}>{this.state.condition.capital_type_text}</div>
                            </div> */}
                            <div className={'item'}>
                                <div className={'p1'}>国家/地区</div>
                                <div className={'p2'}>{this.state.condition.address}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>行业类别</div>
                                <div className={'p2'}>{this.state.condition.industry_type}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>经济类别</div>
                                <div className={'p2'}>{this.state.condition.economic_type_text}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>面积</div>
                                <div className={'p2'}>{this.state.condition.mianji}{this.state.condition.mianji_unit}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>拟投资额</div>
                                <div className={'p2'}>{this.state.condition.touzi_price}万元</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>项目标签</div>
                                <div className={'p2'}>
                                    {this.state.condition.project_tags_text && this.state.condition.project_tags_text.length > 0 ?
                                        <Space wrap>
                                            {this.state.condition.project_tags_text.map((item, index) => (
                                                <Tag key={index} color="blue">{item}</Tag>
                                            ))}
                                        </Space>
                                        : null}
                                </div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>项目简介</div>
                                <div className={'p2'}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: this.state.condition.content }}></div>
                                </div>
                            </div>
                            {this.state.is_special_user ?
                                <div className={'item all'}>
                                    <div className={'p1'}>项目备注</div>
                                    <div className={'p2'}>
                                        <Space style={{ width: '100%' }} direction="vertical">
                                            <TextArea rows={6} style={{ width: '100%˝' }} value={this.state.condition.remark} onChange={(e) => {
                                                let { value } = e.target
                                                this.setState({
                                                    condition: {
                                                        ...this.state.condition,
                                                        remark: value
                                                    }
                                                })
                                            }} />
                                            <Button type='primary' onClick={() => {
                                                let that = this
                                                that.setState({
                                                    loading: true
                                                })
                                                let arr = {
                                                    id: that.props.id,
                                                    remark: that.state.condition.remark
                                                }
                                                fetch('/ProjectResource/remarkSave', {
                                                    method: "POST",
                                                    body: JSON.stringify(arr)
                                                })
                                                    .then(res => res.json())
                                                    .then(data => {
                                                        if (data.status == 1) {
                                                            message.success(data.msg);
                                                        } else {
                                                            message.error(data.msg)
                                                        }
                                                        that.setState({
                                                            loading: false
                                                        })
                                                    })
                                            }}
                                                loading={this.state.loading}>提交</Button>
                                        </Space>
                                    </div>
                                </div>
                                : null}
                        </div>
                        <div className={'view_title'}>项目进度</div>
                        <Genjin id={this.props.id} ref={this.genjin} refresh={() => { }} />
                    </div>
                </Modal>
            </>
        )
    }
}

export default DwView
